import { render } from "./index.vue?vue&type=template&id=a1ee56c0&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=a1ee56c0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-a1ee56c0"

export default script